import PrivacyPolicyDisclaimer from './PrivacyPolicyDisclaimer';
export { PrivacyPolicyDisclaimer };
export default PrivacyPolicyDisclaimer;
